import React from 'react';
import { ImportWrapper, LicenseKeyInput, ImportButton } from './style';

interface TextFileImportProps {
  licenseCode: string;
  setLicenseCode: (value: string) => void;
  onFocus: () => void;
  onBlur: () => void;
}

const TextFileImport = ({ licenseCode, setLicenseCode, onFocus, onBlur }: TextFileImportProps) => {
  return (
    <ImportWrapper>
      <LicenseKeyInput
        type={'text'}
        value={licenseCode}
        onChange={(e) => setLicenseCode(e.target.value)}
        onFocus={() => onFocus()}
        onBlur={(e) => {
          if (!e.target.value) {
            e.target.dataset['invalid'] = 'true';
          } else {
            e.target.dataset['invalid'] = '';
          }
          onBlur();
        }}
        required
      />
      <div data-type={'validate'} />
      <label htmlFor="txt-upload-input">upload txt file</label>
      <ImportButton
        id={'txt-upload-input'}
        type={'file'}
        {...{ webkitdirectory: '', accept: '.txt' }}
        onChange={(e: any) => {
          if (!e.target.files[0]) return;
          const reader = new FileReader();
          reader.onload = function (evt) {
            if (!evt.target?.result) return;

            const fullText: string = evt.target.result as string;
            const lines: string[] = fullText.split('\n');
            const license: string[] = lines[lines.length - 1].split(':');
            const licenseCode: string = license[license.length - 1].trim()

            setLicenseCode(licenseCode);
          };
          reader.readAsText(e.target.files[0]);
        }}
      />
    </ImportWrapper>
  );
};

export default TextFileImport;
